/* unplugin-vue-components disabled */
import {Rest} from 'utils'
import {API_PLAYGROUND} from 'consts/api'
import BuilderInputs from 'components/builder/builder-inputs.vue'

export default {
  components: {BuilderInputs},
  props: {
    datasetName: {
      type: String,
      default: undefined
    },
    vars: {
      type: Object,
      required: true
    },
  },
  emits: ['save'],
  data(){
    return {
      text: '',
      loading: false,
      active_tab: 'vars',
      valid: true,
      fields: {},
      schema: []
    }
  },
  watch: {
    vars(){
      this.schema = []
      this.fields = {}
      Object.entries(this.vars).forEach(([key, type]) => {
        const schema_item = {field: key, title: key, spellcheck: false, maxlength: 4096, type, rows: 6}
        if (type === 'textarea-json') {
          this.fields[key] = `[
  {
    "role": "",
    "content": ""
  }
]`
          this.schema.push(schema_item)
        }
        else {
          this.fields[key] = ''
          this.schema.unshift(schema_item)
        }
      })
    }
  },
  methods: {
    open(){
      this.active_tab = 'vars'
      this.$refs.modal.open()
    },
    close(){
      this.$refs.modal.close()
    },
    async saveSample(){
      this.loading = true
      
      let sample_data = {}
      if (this.active_tab === 'vars') {
        for (const key in this.fields) {
          if (this.vars[key] === 'textarea-json' && this.fields[key]) {
            sample_data[key] = JSON.parse(this.fields[key])
          } 
          else if (this.fields[key]) {
            sample_data[key] = this.fields[key]
          }
        }
      }
      else {
        sample_data = JSON.parse(this.text)
      }

      const payload = {
        dataset_name: this.datasetName,
        input: sample_data
      }
      const rest = new Rest()
      const res = await rest.post(`${API_PLAYGROUND}/datasets/items`, payload)
      this.$emit('save', res)
      $utils.toasts.success('Sample has been saved.')
      this.loading = false
      this.close()
    },
  },
}
